import {
    LOGIN_FORM_SUBMIT_BEGIN,
    LOGIN_FORM_SUBMIT_SUCCESS,
    LOGIN_FORM_SUBMIT_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case LOGIN_FORM_SUBMIT_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case LOGIN_FORM_SUBMIT_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: action.payload
            }
      case LOGIN_FORM_SUBMIT_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }